import { render, staticRenderFns } from "./classes_manage.vue?vue&type=template&id=d631f60e&scoped=true"
import script from "./classes_manage.vue?vue&type=script&lang=ts"
export * from "./classes_manage.vue?vue&type=script&lang=ts"
import style0 from "./classes_manage.vue?vue&type=style&index=0&id=d631f60e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d631f60e",
  null
  
)

export default component.exports